export default [{
    id: 1,
    name: 'Screenshot 1',
    src: './static/images/screenshot/assets/1.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.1',
    }
},
{
    id: 2,
    name: 'Screenshot 2',
    src: './static/images/screenshot/assets/2.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.2',
    }
},
{
    id: 3,
    name: 'Screenshot 3',
    src: './static/images/screenshot/assets/3.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.3',
    }
},
{
    id: 4,
    name: 'Screenshot 4',
    src: './static/images/screenshot/assets/4.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.4',
    }
},
{
    id: 5,
    name: 'Screenshot 5',
    src: './static/images/screenshot/assets/5.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.5',
    }
},
{
    id: 6,
    name: 'Screenshot 6',
    src: './static/images/screenshot/assets/6.png',
    aria: {
        label: 'LOCALE.ACCESSIBILITY.SCREENSHOT.6',
    }
// },
// {
//     id: 7,
//     name: 'Screenshot 7',
//     src: './static/images/screenshot/assets/7.png',
// },
// {
//     id: 8,
//     name: 'Screenshot 8',
//     src: './static/images/screenshot/assets/8.png',
// },
// {
//     id: 9,
//     name: 'Screenshot 9',
//     src: './static/images/screenshot/assets/9.png',
}];